module.exports = __webpack_public_path__ + "static/media/custom-keyboard-bg-stars.dbee25ca.svg";